import React from 'react';
import PropTypes from 'prop-types';
import { Box, Button, Typography } from '@mui/material';

export function GoalsEmptyState({ onDefineGoals }) {
  return (
    <Box textAlign="center" py={4}>
      <Typography variant="subtitle1" gutterBottom>
        Nenhuma meta definida
      </Typography>

      <Typography variant="body2" color="text.secondary" mb={2}>
        Defina quanto da sua receita você quer gastar em cada categoria e acompanhe aqui o quanto já
        foi usado no período.
      </Typography>

      <Button variant="contained" onClick={onDefineGoals}>
        Definir metas
      </Button>
    </Box>
  );
}

GoalsEmptyState.propTypes = {
  onDefineGoals: PropTypes.func.isRequired,
};
